export const APP_NAME = 'RAemBurinkaEarlyRepaymentCalculator'

export const QUERY_CACHE = {
  PARAMS: APP_NAME + '--params',
  CALC_RESPONSE: APP_NAME + '--calc-response'
}

export const MAX_ACC_CHARS = 10
export const ACC_NUMERIC_PATTERN = new RegExp(/^[0-9]+$/)

export const trackingKeys = {
  extraordinaryInstallment: 'Kolik chcete mimořádně splatit?',
  extraordinaryInstallmentId: 'extraordinaryInstallment'
}
